/* eslint-disable security/detect-object-injection */
import React, { useContext, useEffect, useState } from 'react';
import AnimatedPageFade from '../../components/Animations/AnimatedPageFade';
import ApplicationContext from '../../context/ApplicationContext';
import AnimatedImage from '../../components/Animations/AnimatedImage';
import AnimatedButton from '../../components/Button';
import ThreeDotsBlackLoader from '../../components/LoadingDots/ThreeDotsBlack';
import { dataService } from '../../services/data.service';
import moment from 'moment-timezone';
import { chooseLanguageContent } from './chooseLanguageContent';
import { welcomeLanguageContent } from '../Welcome Screen/welcomeLanguageContent';
import { languageCodes } from '../../helpers/languageCodes';

function ChooseLanguage(props) {
    const { handlePage, sessionData, selectedLanguage, setCurrentPage, getFacilityData, facilityData, setLoading, tempToken } = useContext(ApplicationContext);
    const [loader, setLoader] = useState(false);
    const [languageCodeChosen, setLanguageCodeChosen] = useState(selectedLanguage);
    const [languageChosen, setLanguageChosen] = useState(sessionData ? (sessionData.selected_language).charAt(0).toUpperCase() + (sessionData.selected_language).slice(1) : (facilityData.selected_language).charAt(0).toUpperCase() + (facilityData.selected_language).slice(1));

    const handleSubmit = () => {
        setLoader(true);
        const payload = {
            "selected_language": languageChosen.toLowerCase(),
            "language_code": languageCodes[languageChosen]
        }
        dataService.changeLanguage(tempToken, payload).then((res) => {
            if(res.error === false) {
                setLoading(true);
                let tempurl = '';
                if(sessionData) {
                    tempurl = sessionData.choose_language;
                    tempurl = tempurl.split('-')[1];
                    handlePage(tempurl || 'appointments', '', '', '',languageCodes[languageChosen], languageChosen.toLowerCase(), sessionData.document_session);
                } else {
                    handlePage('welcome', '', '', '',languageCodes[languageChosen], languageChosen.toLowerCase());
                }
            }
        })
    }

    return (
        <AnimatedPageFade className='flex flex-col justify-between relative h-welcome gradient-bg rounded-[16px] overflow-hidden'>
            <div className='p-[8px]' data-testid="review_page">
                <p className='text-center font-semibold text-[#64A003] text-[24px] border-b border-[#D7D7D7] py-[8px] lg:text-[26px] xl:text-[32px] 2xl:text-[38px] flex justify-center items-center pb-[10px]'>
                    <AnimatedImage url="/images/review.svg" alt="review" className="mr-[12px]" />
                    {chooseLanguageContent['choose-language'][selectedLanguage]}
                </p>
                <div className='mt-[19px] ml-[12px]'>
                    {chooseLanguageContent['language-content'][selectedLanguage]}
                    <div className='my-[24px] flex flex-col items-center language-height overflow-auto Form-scroll'>
                        {['English', 'Spanish', 'Portuguese', 'Polish', 'Haitian_Creole', 'Arabic', 'Vietnamese', 'Serbian'].map((item, index) => (
                            <div key={`language-${index}`} className='mb-[16px] w-[15%]'>
                                <label className="switch min-w-max">
                                    <input onChange={() => {setLanguageCodeChosen(languageCodes[item]); setLanguageChosen(item)}} type="checkbox" checked={languageCodeChosen === languageCodes[item]} id="mySwitch" />
                                    <span className="slider"></span>
                                    <span className="text-sm text-[#333]" data-testid="languages">{item.replace('_', ' ')}</span>
                                </label>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className='flex mb-[24px] justify-center mx-[16px] w-auto fold-gap'>
                <AnimatedButton disabled={loader}
                    handleClick={() => handleSubmit()}  id="done_button" className={`font-semibold fold-normal-text text-gray w-[200px] h-[40px] ${loader ? '' : 'pl-[41px]'} bg-[#F2F2F2] text-[16px] md:text-[18px] lg:text-[18px] xl:text-[18px] 2xl:text-[18px] justify-center`}>
                    {loader ? <ThreeDotsBlackLoader /> : welcomeLanguageContent['continue'][selectedLanguage]}
                    {!loader && <img src="/images/next.svg" alt="next" className='ml-[1.5em] w-[1.7em] h-[1.7em]' />}
                </AnimatedButton>
            </div>
        </AnimatedPageFade>
    );
}

export default ChooseLanguage;